module.exports = __webpack_public_path__ + "img/journals.ea372c07.svg";